/**
 * Константы стен: материал по умолчанию, типовые толщины, штриховка несущей стены.
 * Сами материалы — в каталоге (`wallSection`).
 */
import { WallMaterial } from "./types";

export const DEFAULT_WALL_MATERIAL: WallMaterial = WallMaterial.Block;

export const THICKNESS_PRESETS = [50, 80, 100, 120, 150, 200, 250] as const;

/** Несущая стена штрихуется красным поверх любого материала — это роль, а не материал. */
export const BEARING_HATCH = {
	background: "#fdecea",
	stroke: "#c0392b",
} as const;
